import React, { Component } from "react";
import BookUtils from "../../../../utils/book-utils";
import BookStore from "../../../../stores/book-store";
import { Dispatcher } from "../../flux";
import Truncate from "../../../ui_elements/truncate";

export default class SearchResult extends Component {
  constructor() {
    super();
    this.state = { page: null };
    this._getPage = this._getPage.bind(this);
    this._goToSearch = this._goToSearch.bind(this);
  }

  componentDidMount() {
    if (this.props.showPage || this.props.needsPage) {
      this._getPage(this.props.isbn);
      Dispatcher.bind(Dispatcher.BOOK_PAGEBREAKS_LOADED, this._getPage);
    }
  }

  componentWillUnmount() {
    if (this.props.showPage) {
      Dispatcher.unbind(Dispatcher.BOOK_PAGEBREAKS_LOADED, this._getPage);
    }
  }

  _goToSearch(e) {
    e.preventDefault();
    Fraction.Helpers.logNPSFeedbackEvent("search-clicks");
    this.props.goToSearch(this.props.originalResult);
  }

  _getPage(isbn) {
    let book;
    let page;
    book = BookStore.get(isbn);

    if (book && book.hasPageBreaks && book.vbkType && book.vbkType !== "dash") {
      if (this.props.originalResult.cfi) {
        page = BookUtils.getPageForCFI(isbn, this.props.originalResult.cfi);
      } else {
        page = BookUtils.getLabelFromIndex(isbn, this.props.originalResult.id);
      }
    }
    if (page) {
      this.setState({ page });
    }
  }

  _buildSearchResult() {
    const { highlightLocPos, highlightLength, cfi } = this.props.result;
    var { text } = this.props.result;
    var query = text.substr(highlightLocPos[0], highlightLength[0]);
    var queryLength = query.length;
    var queryLocation = highlightLocPos[0] + queryLength;

    //Excerpts are ~100 Characters
    var remainingExcerptLength = Math.ceil((100 - queryLength) / 2);
    var searchResult = text.substring(0, queryLocation);

    if (queryLocation > 100) {
      searchResult =
        "..." +
        text.substring(queryLocation - remainingExcerptLength, queryLocation);
    }
    searchResult += text.substring(
      queryLocation,
      queryLocation + remainingExcerptLength
    );

    if (queryLocation + remainingExcerptLength < text.length) {
      searchResult += "...";
    }
    searchResult = searchResult.replace(
      query || query.toLowerCase(),
      '<span class="result-highlight">' + query + "</span>"
    );

    return searchResult;
  }

  render() {
    let text = this._buildSearchResult();
    const cfi = this.props.result;

    return (
      <li className="notecard lib-search" data-cfi={cfi}>
        <a className="search-result" onClick={this._goToSearch} href="#">
          {this.state.page && (
            <p className="page-number">
              {i18n.t("reader.search.page-number")} {this.state.page}
            </p>
          )}
          <p
            className="search-result-context"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </a>
      </li>
    );
  }
}
